import * as HttpService from "../../../../service/HttpService"

/** 系统管理  -> 菜单管理服务 **/

/**
 *  获取菜单列表
 * @param menuTreeId 菜单树id
 * @param parentId 父id
 */
export const menuList = (menuTreeId="", parentId="") => {
    const params = "menuTreeId=" + menuTreeId + "&parentId=" + parentId;
    return HttpService.get(HttpService.DOMAIN + "/sysmgmt/menumgmt/child/list?" + params);
}

/**
 * 菜单项添加
 * @param menuInfo 菜单项信息
 */
export const menuItemAdd = (menuInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/menumgmt/addMenuItemDo", menuInfo);
}

/**
 * 菜单项删除
 * @param itemId 菜单项id
 */
export const menuItemDelete = (itemId) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/menumgmt/deleteMenuItem/" + itemId);
}

/**
 * 菜单项编辑
 * @param itemInfo 菜单项信息
 */
export const menuItemEdit = (itemInfo) => {
    return HttpService.post(HttpService.DOMAIN + "/sysmgmt/menumgmt/editMenuItemDo", itemInfo);
}
